import Url from '../url';
import Data from '../data';
var noop = function () { };
/**
 * Class for http request
 */
var Request = /** @class */ (function () {
    function Request() {
    }
    Request.request = function (option) {
        if (option === void 0) { option = { url: '' }; }
        option.headers = option.headers || {};
        option.method = option.method ? option.method.toUpperCase() : 'GET';
        option.data = option.data || {};
        var method = option.method;
        var contentType = option.headers['Content-Type'] || 'application/x-www-form-urlencoded';
        var contentTypeValue = contentType.split(';')[0];
        var data = option.data;
        var success = option.success && typeof option.success === 'function' ? option.success : noop;
        var error = option.error && typeof option.error === 'function' ? option.error : noop;
        if (method === 'GET') {
            option.url = Url.spliceUrl(option.url, data);
        }
        var xhr = new XMLHttpRequest();
        xhr.responseType = option.responseType || 'json';
        xhr.onreadystatechange = function () {
            if (!xhr || xhr.readyState !== 4) {
                return;
            }
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (xhr.status === 0 && !(xhr.responseURL && xhr.responseURL.indexOf('file:') === 0)) {
                return;
            }
            success(xhr.response);
            xhr = null;
        };
        xhr.onerror = function () {
            error();
            xhr = null;
        };
        xhr.open(method, option.url, true);
        if (option.method === 'POST') {
            if (contentTypeValue === 'application/x-www-form-urlencoded' && !Data.isFormData(data)) {
                var formData = [];
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        formData.push(key + "=" + data[key]);
                    }
                }
                option.data = formData.join('&');
            }
            else if (contentTypeValue === 'application/json') {
                option.data = JSON.stringify(data);
            }
            option.headers['Content-Type'] = contentType;
        }
        if ('setRequestHeader' in xhr) {
            for (var key in option.headers) {
                var val = option.headers[key];
                if (option.headers.hasOwnProperty(key) && typeof val !== 'undefined') {
                    xhr.setRequestHeader(key, val);
                }
            }
        }
        xhr.send(option.method === 'POST' ? option.data : null);
        return xhr;
    };
    return Request;
}());
export default Request;
